import { callApi } from 'utils/api/callApi'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import { DriverStatusType, IGetDriversParams } from 'apps/fleet-planner/types'
import * as Types from 'apps/fleet-planner/types'

export const createDriver = (driver: Types.IDriver): Promise<Types.ICreateDriverResponse> => {
  return callApi({
    endpoint: FP_ENDPOINTS.drivers,
    method: 'POST',
    body: {
      ...driver,
      status: DriverStatusType.active,
    },
  })
}

export const updateDriver = (
  driverId: string,
  changes: Partial<Types.IDriver>
): Promise<Types.ICreateDriverResponse> => {
  return callApi({
    endpoint: `${FP_ENDPOINTS.drivers}/${driverId}`,
    method: 'PUT',
    body: {
      ...changes,
    },
  })
}

export const fetchAllDrivers = (
  params: IGetDriversParams = {
    sortField: 'name',
    sortOrder: 'asc',
  }
): Promise<Types.IGetDriversResponse> => {
  return callApi({
    endpoint: FP_ENDPOINTS.drivers,
    method: 'GET',
    params,
  })
}
